// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__DJDMv","backdrop":"Modal_backdrop__xTnIT","header":"Modal_header__fOQI0","FPS":"Modal_FPS__c-M9t","slider":"Modal_slider__ZnU2U","btn":"Modal_btn__ghtlt"};